import { useContext } from "react";
import { DocumentOrderContext } from "../contexts/DocumentOrderContext";

export const useDocumentOrder = () => {
  const context = useContext(DocumentOrderContext);
  if (context === undefined) throw new Error("DocumentOrderContext was used outside of DocumentOrderProvider");
  return context;
};
